import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=2eb8bc7e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb8bc7e')) {
      api.createRecord('2eb8bc7e', component.options)
    } else {
      api.reload('2eb8bc7e', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=2eb8bc7e", function () {
      api.rerender('2eb8bc7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/layout.vue"
export default component.exports